import React, { Ref } from "react";

import "./CheckBox.scss";
interface IProps {
  children: React.ReactNode;
  name: string;
}

const CheckBox = React.forwardRef(
  (
    { children, name, ...inputProps }: IProps,
    ref: Ref<HTMLInputElement> | undefined
  ) => {
    return (
      <div className="form-checkbox">
        <input
          id={name}
          type="checkbox"
          name={name}
          ref={ref}
          {...inputProps}
        />
        <label htmlFor={name}>{children}</label>
      </div>
    );
  }
);

CheckBox.displayName = "CheckBox"; // Add this line

export default CheckBox;
